import { GetStaticProps, GetStaticPropsContext } from 'next'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from '../container/Layout'
import styles from '../styles/about.module.scss'

export default function About({ locale }): JSX.Element {
	const { t } = useTranslation(['about'])
	return (
		<Layout>
			<div className="inner">
				<header className={styles.header}>
					<h1 className={styles.title}>{t('about:title')}</h1>
				</header>
				<section className={styles.section}>
					<article className={styles.article}>
						{locale === 'en' ? (
							<>
								<p>
									niklas pelle fuchs (art director) + justin fox (software engineer) – 2 design freelancers from hamburg
									/ berlin
								</p>
								<p>
									you can hire us for logo, corporate + editorial design, commercial campagnes, mobile application
									development, frontend and backend development, a.m.m.
									<br />
									if 2 foxes aren‘t wise enough, we will call our frinds to help us for your job
									<br />
									we are well connected to texter, illustrators, 3d + interior designers, developeres, seo experts
									a.m.m.
								</p>
								<p>
									FUCHSFOX is excisting since 2014, we were working for any company size in different countries / we‘re
									looking forward to your request! :)
									<br />
									<span>
										&nbsp;
										<a className={styles.link} href="mailto:hello@fuchsfox.com">
											mail
										</a>
									</span>
									<span>&nbsp;/&nbsp;</span>
									<span>
										<a className={styles.link} href="tel:+4915209001910">
											call
										</a>
									</span>
								</p>
							</>
						) : (
							<>
								<p>
									niklas pelle fuchs (art director) + justin fox (software engineer) – 2 design freelancer aus hamburg /
									berlin
								</p>
								<p>
									wir machen logos, corporate designs + editorial und werbekampagnen, entwicklung mobiler anwendungen,
									front- und backend-entwicklung u.v.m. wenn 2 füchse nicht reichen, holen wir unsere freunde dazu – wir
									sind gut vernetzt mit textern, illustratoren, 3d designern, innenarchitekten, seo-experten u.v.m
								</p>
								<p>
									FUCHSFOX gibt es seit 2014 – seit dem waren wir für jede unternehmensgröße aus verschiedenen ländern
									tätig wir freuen uns auf ihre anfrage! :)
									<br />
									<span>
										&nbsp;
										<a className={styles.link} href="mailto:hello@fuchsfox.com">
											mail
										</a>
									</span>
									<span>&nbsp;/&nbsp;</span>
									<span>
										<a className={styles.link} href="tel:+4915209001910">
											anrufen
										</a>
									</span>
								</p>
							</>
						)}
					</article>
				</section>
			</div>
		</Layout>
	)
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => {
	return {
		props: {
			locale,
		},
	}
}
